import React from 'react';
import {
  LayoutDashboard, Server, SplitSquareHorizontal, Tags, Receipt, Gauge, Activity, Wallet, Calculator,
} from 'lucide-react';
import {
  Sidebar, SidebarContent, SidebarHeader, SidebarFooter, SidebarGroup, SidebarGroupLabel,
  SidebarGroupContent, SidebarMenu, SidebarMenuItem, SidebarMenuButton,
} from '@/components/ui/sidebar';

export const SCREENS = [
  { key: 'overview', label: 'Overview', icon: LayoutDashboard },
  { key: 'provider', label: 'By provider', icon: Server },
  { key: 'attribution', label: 'Attribution', icon: SplitSquareHorizontal },
  { key: 'pricing', label: 'Pricing', icon: Tags },
  { key: 'manual', label: 'Manual costs', icon: Receipt },
  { key: 'quality', label: 'AI quality', icon: Gauge },
  { key: 'harness', label: 'Harness ops', icon: Activity },
  { key: 'economics', label: 'Economics', icon: Calculator },
];

export default function AppSidebar({ active, onNavigate }) {
  return (
    <Sidebar>
      <SidebarHeader>
        <div className="flex items-center gap-2.5 px-2 py-1.5">
          <div className="flex size-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <Wallet className="size-4" />
          </div>
          <div className="min-w-0">
            <div className="truncate text-[13.5px] font-semibold leading-tight">Healther Ops</div>
            <div className="truncate text-[11px] text-muted-foreground">Cost &amp; AI console</div>
          </div>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Dashboards</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {SCREENS.map((s) => (
                <SidebarMenuItem key={s.key}>
                  <SidebarMenuButton
                    isActive={active === s.key}
                    tooltip={s.label}
                    onClick={() => onNavigate(s.key)}
                  >
                    <s.icon />
                    <span>{s.label}</span>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>
        <div className="px-2 py-1 text-[10.5px] leading-relaxed text-muted-foreground">
          Platform super-admin · reads the <span className="font-medium">healther-ops</span> project only.
        </div>
      </SidebarFooter>
    </Sidebar>
  );
}
